import { Tag } from 'antd';
import React from 'react';

type Props = {
  value?: boolean;
};

export default function BooleanTag({ value }: Props) {
  return (
    <Tag style={{ marginRight: 0 }} color={value ? '#096609' : '#ae0b0b'}>
      {value ? 'Yes' : 'No'}
    </Tag>
  );
}
